import { useAsync, UseAsyncStatus } from '@shared/async';
import { PaginationRequest, SortingInfo } from '@shared/pagination';
import React, { useState } from 'react';
import { HiOutlinePencil } from 'react-icons/hi2';

import { Button } from '@/components-new/button';
import { useCoverageService } from '@/features/coverage/api/use-coverage-service';

import { BulkPdlEditDialog } from './bulk-pdl-edit-dialog';
import { FilterInputs } from './index/coverage-filters';

export type BulkEditPdlButtonProps = {
  filters: FilterInputs & PaginationRequest & SortingInfo;
  onSuccess: () => void;
};

export const BulkEditPdlButton = ({ filters, onSuccess }: BulkEditPdlButtonProps) => {
  const [showBulkPdlEditDialog, setShowBulkPdlEditDialog] = useState(false);

  const { searchForAllMatchingIds } = useCoverageService();
  const request = useAsync(searchForAllMatchingIds);
  const loading = request.status === UseAsyncStatus.Pending;

  return (
    <>
      <Button
        disabled={loading}
        aria-label="Bulk Edit Coverage Data"
        title="Bulk Edit Coverage Data"
        onClick={async () => {
          const canUseBulkPdlEdit = filters.states && filters.states.length > 0;

          if (canUseBulkPdlEdit) {
            await request.execute(filters);
          }

          setShowBulkPdlEditDialog(true);
        }}
      >
        <HiOutlinePencil/>
      </Button>
      <BulkPdlEditDialog
        open={showBulkPdlEditDialog}
        onClose={() => setShowBulkPdlEditDialog(false)}
        onSuccess={() => {
          setShowBulkPdlEditDialog(false);
          onSuccess();
        }}
        filters={filters}
        idsToUpdate={request.value ?? []}
      />
    </>
  );
};
